'use client';

import { useEffect, useRef } from 'react';
import type { PageSectionAnalyticsTrackingProps } from './types';

export function PageSectionAnalyticsTracking({
    sectionId,
    eventCallback,
    enabled = true,
    OnIntersect = () => null,
    children,
}: PageSectionAnalyticsTrackingProps) {
    const sectionRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (!('IntersectionObserver' in window)) {
            return undefined;
        }

        const divElement = sectionRef.current;

        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting && enabled) {
                    if (eventCallback) {
                        eventCallback();
                    }

                    observer.unobserve(entry.target);
                }

                if (entry.isIntersecting) {
                    OnIntersect();
                }
            });
        });

        if (divElement) {
            observer.observe(divElement);
        }

        return () => {
            if (divElement) {
                observer.unobserve(divElement);
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps -- throwing build error and do not want to break
    }, [eventCallback, sectionId]);

    return (
        <div ref={sectionRef} id={sectionId}>
            {children}
        </div>
    );
}
